<template lang="pug">
#staff-members
  section.section.page-section.container.is-fluid
    spinner(v-if="settings.loading")
    .blocks(v-else)
      .block(
        v-for="(staffMember, $index) in staffMembers"
        :key="staffMember.id"
        :class="{ 'is-even': $index % 2 === 0, 'is-odd': $index % 2 !== 0 }"
      )
        .block-image
          cl-img(
            v-if="staffMember._embedded.profile_image"
            :cl-id="staffMember._embedded.profile_image.cl_id"
            :transform="{ width: 640, height: 360 }"
          )
        .block-details
          .content.mobile-padding
            h3
              span.is-size-2-desktop.is-size-3-touch {{ staffMember.full_name }}
              small {{ staffMember.title }}
            read-more.is-size-5(:value="staffMember.bio")
</template>

<script>
import { mapGetters } from 'vuex';
import ReadMore from '@/components/ReadMore.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'staff-page',
  components: {
    ReadMore,
    Spinner,
  },
  computed: {
    ...mapGetters({
      staffMembers: getterTypes.GET_STAFF_MEMBERS,
    }),
  },
  async created() {
    if (this.staffMembers.length === 0) {
      this.settings.loading = true;
      await this.$store.dispatch(actionTypes.DO_GET_STAFF_MEMBERS, {
        zoom: 'profile_image',
      });
      this.settings.loading = false;
    }
  },
  data() {
    return {
      settings: {
        loading: false,
      },
    };
  },
};
</script>

<style lang="scss">
#staff-members {
  @include blocks;
  .blocks {
    .block {
      .block-details {
        h3 {
          small {
            padding-left: 0.5rem;
          }
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  #staff-members {
    .page-section {
      padding-top: 0;
    }
    .blocks {
      .block {
        .block-details {
          h3 {
            small {
              padding-left: 0;
              padding-top: 0.75rem;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
